import { Companies } from '../../companies/companies';
import { companiesURLParameters as companies } from '../../constants/url/companiesURLParameters';
import { flowsURLParameters as flows } from '../../constants/url/flowsURLParameters';
import { isValidCompanyName } from '../company/isValidCompanyName';
import { isValidFlowName } from '../flow/isValidFlowName';

export const getModalCloseButtonAvailability = (
  companyName: string | null,
  flow: string | null,
): boolean => {
  if (!companyName || !flow) {
    return false;
  }
  if (!isValidCompanyName(companyName, Companies) || !isValidFlowName(companyName, flow)) {
    return false;
  }

  const { fishbrain, aspira } = companies;
  const flowsWithDisabledCloseButton = [
    `${fishbrain}.${flows.fishbrain.becomePro}`,
    `${aspira}.${flows.aspira.becomePro}`,
  ];
  const flowIdentifier = `${companyName}.${flow}`;

  return flowsWithDisabledCloseButton.includes(flowIdentifier);
};
